var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8677 26.9805C14.6226 26.9805 14.0854 26.0527 13.6948 24.7832L11.9126 18.9849C11.6196 18.0449 11.6807 17.3369 12.291 16.6777L25.0107 2.76172C25.1816 2.56641 25.1572 2.32227 25.0229 2.18799C24.8765 2.0415 24.6445 2.0293 24.4492 2.2002L10.5332 14.9443C9.80078 15.5913 9.20264 15.6035 8.22607 15.2983L2.3667 13.4917C1.12158 13.1011 0.218262 12.5762 0.218262 11.3433C0.218262 10.2935 1.02393 9.57324 2.12256 9.1582L23.5215 0.967285C24.022 0.771973 24.4858 0.674316 24.9009 0.674316C25.8896 0.674316 26.5366 1.30908 26.5366 2.31006C26.5366 2.71289 26.4268 3.17676 26.2314 3.68945L18.0771 25.0273C17.6255 26.2114 16.9053 26.9805 15.8677 26.9805Z",
    fill: "#3C1460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.90e4a3f10db6d1f65efa14b61027a83a.svg";
export { ForwardRef as ReactComponent };